import script from "./FormInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInput.vue?vue&type=script&setup=true&lang=js"

import "./FormInput.vue?vue&type=style&index=0&id=188f0d4a&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188f0d4a"]])

export default __exports__